<template>
	<div>
		<h2>NO MODULE FOUND</h2>
		<pre v-html="data"></pre>
	</div>
</template>

<script>
export default {
	name: 'no-module',
	props: ['data'],
	computed: {},
	components: {},
}
</script>
